import { render, staticRenderFns } from "./AgendaAppointments.vue?vue&type=template&id=042e5a4f&scoped=true"
import script from "./AgendaAppointments.vue?vue&type=script&lang=js"
export * from "./AgendaAppointments.vue?vue&type=script&lang=js"
import style0 from "./AgendaAppointments.vue?vue&type=style&index=0&id=042e5a4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042e5a4f",
  null
  
)

export default component.exports